<!-- FILTER BAR -->
<section class="filtering" *ngIf="showData">
  <button
    mat-button
    class="button_small"
    style="width: 300px"
    (click)="openScheduledDialog()"
    [disabled]="selection.selected.length <= 0"
  >
    Cancel Scheduled Jobs
  </button>
</section>

<ng-container *ngIf="!showData">
  <div class="loading-spinner">
    <mat-spinner strokeWidth="3" diameter="50"></mat-spinner>
    Loading All Items
  </div>
</ng-container>

<div [hidden]="!showData">
  <table mat-table [dataSource]="dataSource" id="dataTable">
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell noItems" colspan="4">
        No scheduled jobs available to be shown
      </td>
    </tr>
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </th>
      <th mat-header-cell *matHeaderCellDef style="font-size: 10px">
        Select Fields
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Canvas Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Canvas Type</th>
      <td mat-cell *matCellDef="let element">{{ element.canvasType }}</td>
    </ng-container>

    <!-- modified Column -->
    <ng-container matColumnDef="modified">
      <th mat-header-cell *matHeaderCellDef>Scheduled Publish Date</th>
      <td mat-cell *matCellDef="let element">
        {{ formatModified(element.updated_at) }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      (click)="selection.toggle(row)"
    ></tr>
  </table>
  <span class="selectedItems" *ngIf="selection.selected.length > 0"
    >Currently {{ selection.selected.length }} item(s) selected</span
  >
</div>
